export function formatRating(rating?: number | null): string {
  if (rating == null || isNaN(rating)) return ''

  // whole number → always one decimal place
  if (Number.isInteger(rating)) {
    return rating.toFixed(1)
  }

  // round to 2 decimals
  const rounded = Math.round(rating * 100) / 100
  const asString = rounded.toString()

  // if that rounding made it an integer again (e.g. 5.00 → 5)
  // show one decimal
  if (Number.isInteger(rounded)) {
    return rounded.toFixed(1)
  }

  // otherwise leave it as-is (1 or 2 decimals)
  return asString
}
